module.exports = __webpack_public_path__ + "d3961b4dcfd7be967ee904191df81fb6.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-ecpcc.png
// module id = 3217
// module chunks = 69